import { render, staticRenderFns } from "./VThOrdination.vue?vue&type=template&id=5c122802&scoped=true&"
import script from "./VThOrdination.vue?vue&type=script&lang=js&"
export * from "./VThOrdination.vue?vue&type=script&lang=js&"
import style0 from "./VThOrdination.vue?vue&type=style&index=0&id=5c122802&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c122802",
  null
  
)

export default component.exports